import React, { useState } from "react";
import { AllowanceBox,  HeaderBorder } from "../../../style";
import {
  Typography,
  Dialog,
  Box,
  Row,
  Col,
  Divider,
  Flex,
  SelectField,
  InputField,
  FabButton,
  Avatar,
} from "../../../../ppui";
import GlobalTable from "../../../../components/global-table";
import { headers } from "./leave-request.data";
import { TbPlus, TbTrash } from "react-icons/tb";
import useLeaveRequestService from "./leave-request-service";
import { logger } from "../../../../utils/logger";
import { getDateProperFormatForInputFn } from "../../../../utils/common";
import useLeavePolicyService from "../../../leave-policy/leave-policy-service";


const EmpLeaveRequest = ({ openSnackbar }) => {
  const {
    handleNextPage,
    leaveRequestLists,
    handlePreviousPage,
    handleRowsPerPageChange,
    setSearchQuery,
    rowsPerPage,
    currentPage,
    totalPages,
    searchQuery,
    getEmployeeRequestLeaveInformation,
    leaveDetails,
    handleAddRow,
    handleDeleteRow,
    handleInputChange
  } = useLeaveRequestService({ openSnackbar });

  const [LeaveInfoEdit, setLeaveInfoEdit] = useState(false);
  const LeaveInfoModalClose = () => setLeaveInfoEdit(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [requestLeaveInfo, setRequestLeaveInfo] = useState(null);
  const {adminLeaveListsInfo}= useLeavePolicyService()

  const FetchDataFromRow = (row) => {
    setSelectedRow(row);
    getEmployeeRequestLeaveInformation(row?.request_id).then((data) => {
      setRequestLeaveInfo(data);
      setLeaveInfoEdit(true)
    })
  }

  logger.log(adminLeaveListsInfo, "dipronil")

  return (
    <>
        <GlobalTable
          headers={headers(currentPage, rowsPerPage)}
          rows={leaveRequestLists}
          ActiveSort={false}
          searchBox={true}
          columnManagement={true}
          avatar={true}
          stickyHeader="true"
          FetchDataFromRow={FetchDataFromRow}
          rowsPerPage={rowsPerPage}
          currentPage={currentPage}
          totalPages={totalPages} // Pass total pages
          handleNextPage={handleNextPage} // Pass next page handler
          handlePreviousPage={handlePreviousPage} // Pass previous page handler
          handleRowsPerPageChange={handleRowsPerPageChange} // Pass rows-per-page handler
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          actionLeft={
            <>
              <Typography variant="h5" mb="0">
              Requested leave
              </Typography>
            </>
          }
        />

      {/* Leave-InformationModal */}
      <Dialog
        title="Requested Leave"
        closeButton={false}
        fullWidth
        maxWidth="md"
        buttonName={"Close"}
        open={LeaveInfoEdit}
        onClose={LeaveInfoModalClose}
        onSubmit={LeaveInfoModalClose}
        action={true}
        separator
        bodyScroll={true}
      // footer={
      //   <Box mr={"auto"}>
      //     <Switchbox
      //       label="Not work for full month"
      //       color="Primary"
      //       size="lg"
      //     />
      //   </Box>
      // }
      >
        <Box Padding>
          <Row alignItem="center">
            <Col sm={12}>
              <Row alignItem="center">

                <Col sm={6}>
                  <HeaderBorder>
                    <Flex alignItem="center" gap={20}>
                      <Col sm={"auto"}>
                        <Avatar
                          size="lg"
                          initials={`${selectedRow?.employees?.first_name.trim().substring(0, 1).toUpperCase()}${selectedRow?.employees?.last_name.trim().substring(0, 1).toUpperCase()}`}
                          src={selectedRow?.employees?.employee_image}
                        />
                      </Col>
                      <Box>
                        <Typography variant="h6" mb={10}>
                          {`${selectedRow?.employees?.first_name} ${selectedRow?.employees?.last_name}`}
                        </Typography>
                        <Typography variant="body2">{selectedRow?.employees?.employee_code}</Typography>
                      </Box>
                    </Flex>
                  </HeaderBorder>
                </Col>
                <Col sm={3}>
                  <HeaderBorder>
                    <Typography variant="body1" mb={"0"}>
                      Department
                    </Typography>
                    <Typography variant="body2" mb={"0"}>
                      {selectedRow?.employees?.departments?.dept_name}
                    </Typography>
                  </HeaderBorder>
                </Col>
                <Col sm={3}>
                  <Typography variant="body1" mb={"0"}>
                    Designation
                  </Typography>
                  <Typography variant="body2" mb={"0"}>
                    {selectedRow?.employees?.designations?.designation_name}
                  </Typography>
                </Col>

              </Row>
            </Col>
          </Row>
        </Box>
        <Divider gap={20} />
        <AllowanceBox>
          <Flex gap={20} direction={"column"} alignItems="flex-start">

            <Row alignItems="center">
              {/* <Col>
                <Box className="value">Subject</Box>
                <Box className="label">Casual Leave</Box>
              </Col> */}
            </Row>
            {
              requestLeaveInfo?.reason != null && <>
                <Box>
                  <Box className="value">Reasons</Box>
                  <Box className="label">{requestLeaveInfo?.reason}</Box>
                </Box>
              </>
            }


            <Divider />
            <Row alignItems="center">
              <Col>
                <Flex
                  alignItems="center"
                  gap={{ md: 20, lg: 40, xxl: 60 }}
                >
                  <Box>
                    <Box className="label">Start Date</Box>
                    <Box className="value">{getDateProperFormatForInputFn(requestLeaveInfo?.start_date)}</Box>
                  </Box>

                  <Box>
                    <Box className="label">End Date</Box>
                    <Box className="value">{getDateProperFormatForInputFn(requestLeaveInfo?.end_date)}</Box>
                  </Box>
                  <Box>
                    <Box className="label">Requested</Box>
                    <Box className="value">{requestLeaveInfo?.leave_days} Days</Box>
                  </Box>
                </Flex>
              </Col>
              <Col md="auto">
                <SelectField
                  required
                  fullWidth
                  label="Status"
                  options={[
                    { id: "approved", name: "Approve" },
                    { id: "option2", name: "Reject" },
                  ]}
                  defaultValue={requestLeaveInfo?.status}
                  placeholder="Select Here..."
                  variant="standard"
                  size="sm"
                  disabled={true}
                />
              </Col>
            </Row>
          </Flex>

        </AllowanceBox>
        <Divider gap={20} />
        <Typography variant="h6" mb={10}>

        </Typography>

        <Typography variant="h5">
          Leave Break Up
        </Typography>

        <Flex direction="column" gap={20}>
          {leaveDetails.map((detail, index) => (
            <Row key={index} rowGap>
              <Col sm={12} md={3}>
                <SelectField
                  fullWidth
                  required
                  label="Leave Type"
                  options={adminLeaveListsInfo}
                  defaultValue={detail.leave_type_id}
                  onChange={(e) =>
                    handleInputChange(index, "leave_type_id", e.target.value)
                  }
                  placeholder="Select Here..."
                  disabled = {true}
                />
              </Col>

              <Col sm={12} md={3}>
                <InputField
                  fullWidth
                  label="Start Date"
                  type="date"
                  value={new Date(detail.start_date).toISOString().split("T")[0]}
                  onChange={(e) =>
                    handleInputChange(index, "start_date", e.target.value)
                  }
                  valueSinc={!!detail.start_date}
                  placeholder="Start Date"
                  readOnly = {true}
                />
              </Col>

              <Col sm={12} md={3}>
                <InputField
                  fullWidth
                  label="End Date"
                  type="date"
                  value={new Date(detail.end_date).toISOString().split("T")[0]}
                  onChange={(e) =>
                    handleInputChange(index, "end_date", e.target.value)
                  }
                  valueSinc={!!detail.end_date}
                  placeholder="End Date"
                  readOnly = {true}
                />
              </Col>

              <Col sm={12} md={2}>
                <InputField
                  fullWidth
                  label="Days"
                  type="number"
                  value={
                    detail.start_date && detail.end_date
                      ? Math.ceil(
                        (new Date(detail.end_date) - new Date(detail.start_date)) /
                        (1000 * 60 * 60 * 24) + 1
                      )
                      : 0
                  }
                  readOnly
                  valueSinc = {true}
                  placeholder="00"
                />
              </Col>

              <Col sm={"auto"}>
                {index === leaveDetails.length - 1 ? (
                  <FabButton
                    color="primary"
                    icon={<TbPlus />}
                    onClick={handleAddRow}
                    shape="box"
                    variant="outlined"
                    disabled={true}
                  />
                ) : (
                  <FabButton
                    color="primary"
                    icon={<TbTrash />}
                    onClick={() => handleDeleteRow(index)}
                    shape="box"
                    variant="outlined"
                    disabled={true}
                  />
                )}
              </Col>
            </Row>
          ))}
        </Flex>
        {/* <Row rowGap>
          <Col sm={12} md={4}>
            <InputField
              fullWidth
              label="Casual Leave"
              type="number"
                  placeholder="Type Here..."
              helperText={
                <>
                 CL Balance is 6
                </>
              }
            />
          </Col>


          <Col sm={12} md={4}>
          <InputField
              fullWidth
              label="Privilege Leave"
              type="number"
              placeholder="Type Here..."
              helperText={
                <>
             PL Balance is 4 
                </>
              }
            />
          </Col>

          <Col sm={12} md={4}>
          <InputField
              fullWidth
              label="Medical Leave"
              type="number"
                  placeholder="Type Here..."
              helperText={
                <>
                ML Balance is 3 
                </>
              }
            />
          </Col>

          <Col sm={12} md={4}>
          <InputField
              fullWidth
              label="Sanction Leave"
              type="number"
                  placeholder="Type Here..."
            
            />
          </Col>
          <Col sm={12} md={4}>
          <InputField
              fullWidth
              label="LOP"
              type="number"
                 placeholder="Type Here..."
              
            />
          </Col>

        </Row> */}
      </Dialog>
      {/* Leave-InformationModal */}
    </>
  );
};

export default EmpLeaveRequest;
